import { CategoryResponseType, CategoryClientResponseType, ICategory, ICategoryRepo } from '@/entity/category/category.types';

export class CategoryR implements ICategoryRepo {
    total: number;
    data: ICategory[] = []
    constructor(data: CategoryResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }

}

/* export default class Category implements ICategory {
    id: number | null;
    name: string;
    color: string | null;
    icon: string | null;
    constructor(data: CategoryResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.color = data.color;
        this.icon = data.icon;
    }
} */
export class CategoryClient implements ICategory {
    id: number | null;
    name: string;
    color: string | null;
    icon: string | null;
    constructor(data: CategoryClientResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.color = data.color;
        this.icon = data.icon;
    }
}